import React from "react";
import { Check, Search, Bed, Coffee, User } from "lucide-react";
import { useBooking } from "../context/BookingContext";


const StepIndicator: React.FC = () => {
  const { formData, selectedHotel, setCurrentStep, currentStep } = useBooking();

  // Use hotel-specific path for navigation within booking flow
  const basePath = `/${selectedHotel?.slug || 'hotel-adriatica'}`;

  const steps = [
    {
      number: 1,
      title: "Recherche",
      path: basePath,
      icon: Search,
      completed: currentStep > 1,
      clickable: true,
    },
    {
      number: 2,
      title: "Chambres",
      path: `${basePath}/rooms`,
      icon: Bed,
      completed: currentStep > 2,
      clickable: !!(formData.checkIn && formData.checkOut),
    },
    {
      number: 3,
      title: "Extras",
      path: `${basePath}/extras`,
      icon: Coffee,
      completed: currentStep > 3,
      clickable: currentStep > 2 || currentStep === 3,
    },
    {
      number: 4,
      title: "Vos infos",
      path: `${basePath}/customer`,
      icon: User,
      completed: false,
      clickable: currentStep > 3 || currentStep === 4,
    },
  ];

  const handleStepClick = (stepNumber: number, clickable: boolean) => {
    if (clickable) {
      setCurrentStep(stepNumber);
    }
  };

  return (
    <div className="px-4 py-6  bg-white shadow-sm">
      <div className="mx-auto max-w-4xl">
        <div className="flex justify-between items-center">
          {steps.map((step, index) => (
            <React.Fragment key={step.number}>
              {/* Step item */}
              <div
                className={`flex flex-col items-center ${
                  step.clickable
                    ? "cursor-pointer"
                    : "cursor-not-allowed opacity-70"
                }`}
                onClick={() => handleStepClick(step.number, step.clickable)}
              >
                {/* Circle with number or check */}
                <div
                  className={`
                    w-12 h-12 rounded-full flex items-center justify-center mb-2
                    ${
                      currentStep === step.number
                        ? "text-white"
                        : step.completed
                        ? "text-white"
                        : "bg-gray-200 text-gray-600"
                    }
                    transition-all duration-300
                  `}
                  style={{
                    backgroundColor:
                      currentStep === step.number
                        ? "var(--hotel-secondary-color)"
                        : step.completed
                        ? "var(--hotel-primary-color)"
                        : undefined,
                  }}
                >
                  {step.completed ? (
                    <Check className="w-6 h-6" />
                  ) : (
                    <step.icon className="w-6 h-6" />
                  )}
                </div>
                {/* Step title */}
                <span
                  className={`
                    text-sm font-medium 
                    ${
                      currentStep === step.number
                        ? ""
                        : step.completed
                        ? ""
                        : "text-gray-500"
                    }
                  `}
                  style={{
                    color:
                      currentStep === step.number
                        ? "var(--hotel-secondary-color)"
                        : step.completed
                        ? "var(--hotel-primary-color)"
                        : undefined,
                  }}
                >
                  {step.title}
                </span>
              </div>

              {/* Connector line - only between steps */}
              {index < steps.length - 1 && (
                <div
                  className={`
                    flex-grow h-1 mx-2
                    ${index < currentStep - 1 ? "bg-[#87764e]" : "bg-gray-200"}
                    transition-all duration-300
                  `}
                />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StepIndicator;
